import React from "react";
import PasswordEntropy from "./passwordEntropy";

export const getStrength = (pwd) => {
    if (pwd.length < 8) {
        return {
            label: "Too Short",
            value: 10,
            color: "bg-[#9E1E41]",
            textColor: "text-[#461220]",
        };
    }

    const entropy = PasswordEntropy.calculate(pwd);

    if (entropy > 100)
        return {
            label: "Excellent!",
            value: 100,
            color: "bg-[#748A2B]",
            textColor: "text-[#234311]",
        };
    if (entropy > 80)
        return {
            label: "Great",
            value: 80,
            color: "bg-[#9FBD3C]",
            textColor: "text-[#48561C]",
        };
    if (entropy > 60)
        return {
            label: "Good",
            value: 60,
            color: "bg-cta",
            textColor: "text-primary",
        };
    if (entropy > 40)
        return {
            label: "Average",
            value: 40,
            color: "bg-[#bb5c3f]",
            textColor: "text-[#8C4530]",
        };

    return {
        label: "Weak",
        value: 20,
        color: "bg-[#9E1E41]",
        textColor: "text-[#461220]",
    };
};

export default function PasswordStrengthMeter({ value, showStrength }) {
    if (!value || !showStrength) return null;

    const strength = getStrength(value || "");

    return (
        <div className="flex flex-row items-center">
            <div className="flex-[9] relative h-2 w-full rounded-full bg-gray-200">
                <div
                    className={`h-2 rounded-full transition-all duration-300 ${strength.color}`}
                    style={{ width: `${strength.value}%` }}
                />
            </div>
            <div className="flex-[1] text-right">
                <span className={`text-xs font-medium ${strength.textColor}`}>
                    {strength.label}
                </span>
            </div>
        </div>
    );
}
